<h2 mat-dialog-title>
  <mat-icon color="primary">{{ icon }}</mat-icon>
  {{ data.title || 'Message' }}
</h2>

<mat-dialog-content [innerHTML]="data.markdown ? htmlMessage : data.message"></mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <ng-container *ngIf="data.actions?.length; else defaultActions">
    <ng-container *ngFor="let action of data.actions">
      <button
        class="dialog-action-button"
        *ngIf="action.raised; else flatAction"
        mat-raised-button
        [color]="action.color || 'primary'"
        (click)="onAction(action.value)">
        {{ action.label }}
      </button>
      <ng-template #flatAction>
        <button
          class="dialog-action-button"
          mat-button
          [color]="action.color || 'primary'"
          (click)="onAction(action.value)">
          {{ action.label }}
        </button>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #defaultActions>
    <ng-container *ngIf="data.confirm; else okOnly">
      <button mat-button color="warn" (click)="onConfirm(false)">No</button>
      <button mat-button color="primary" (click)="onConfirm(true)">Yes</button>
    </ng-container>
    <ng-template #okOnly>
      <button mat-button color="primary" (click)="dialogRef.close()">OK</button>
    </ng-template>
  </ng-template>
</mat-dialog-actions>
